import type { FirebaseOptions } from 'firebase/app'

const dev: FirebaseOptions = {
  apiKey: 'AIzaSyDwONYltmM3vsbzeEl1uENKrt0qJszTRis',
  appId: '1:1045552266892:web:a9620d2f54645d2fd505a9',
  messagingSenderId: '1045552266892',
  measurementId: 'G-08XRDQP237',
  projectId: 'upadelmatch-club-dev',
  authDomain: 'upadelmatch-club-dev.firebaseapp.com',
  storageBucket: 'upadelmatch-club-dev.firebasestorage.app',
}

const prod: FirebaseOptions = {
  apiKey: 'AIzaSyBYRlO-xQC2vf_gxElHGMkhxCRq3UJqEk0',
  appId: '1:704207172700:web:78410a921a30b53eda6299',
  messagingSenderId: '704207172700',
  measurementId: 'G-ZE1YKRPX4W',
  projectId: 'upadelmatch-club-prod',
  authDomain: 'upadelmatch-club-prod.firebaseapp.com',
  storageBucket: 'upadelmatch-club-prod.firebasestorage.app',
}

export type Env = 'dev' | 'prod'

// `VITE_ENV` is injected at build time from `vite.config.ts` `define` block,
// derived from Vite's `mode` (default=production for prod, --mode development
// for dev). Hostname sniffing was removed in May 2026 after a prod incident:
// clubmanager.upadelmatch.com fell through the host check and silently loaded
// the dev Firebase project.
function resolveEnv(): Env {
  const fromVite = import.meta.env['VITE_ENV']
  if (fromVite === 'prod' || fromVite === 'dev') return fromVite
  if (import.meta.env.PROD) {
    throw new Error(
      'VITE_ENV missing on production build — set it in .env.production / .env.development.',
    )
  }
  return 'dev'
}

export const env: Env = resolveEnv()

export const firebaseConfig: FirebaseOptions = env === 'prod' ? prod : dev
